import { Component, NgZone } from "@angular/core";
import { FirmwareApprovalRepo } from "../../../repos/firmware/approval.repo";
import { ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./list.component.html",
})
export class FirmwareApprovalListComponent {
  public entries: any;

  constructor(
    public repo: FirmwareApprovalRepo,
    public zone: NgZone,
    public route: ActivatedRoute
  ) {
    const type = this.route.snapshot.data["type"];
    this.zone.run(() => {
      this.repo.getListPromise().then((u: any) => {
        const prefix = type === "mcu" ? "ref.mcu" : "ref.firmware";

        this.entries = u
          .filter((item) => item.reference?.startsWith(prefix))
          .sort(
            (a, b) =>
              new Date(b.approved_on).getTime() -
              new Date(a.approved_on).getTime()
          );
      });
    });
  }
}
